import { render, staticRenderFns } from "./SingleLineText.vue?vue&type=template&id=67f30af4&scoped=true"
import script from "./SingleLineText.vue?vue&type=script&lang=js"
export * from "./SingleLineText.vue?vue&type=script&lang=js"
import style0 from "./SingleLineText.vue?vue&type=style&index=0&id=67f30af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f30af4",
  null
  
)

export default component.exports